import { userClient } from './client';

export const authApi = {
  register: (data: Record<string, string>) => userClient.post('/auth/register', data),

  login: (email: string, password: string) =>
    userClient.post('/auth/login', { email, password }),

  logout: (refreshToken: string) =>
    userClient.post('/auth/logout', { refreshToken }),

  refreshToken: (refreshToken: string) =>
    userClient.post('/auth/refresh-token', { refreshToken }),

  verifyEmail: (token: string) =>
    userClient.post('/auth/verify-email', { token }),

  forgotPassword: (email: string) =>
    userClient.post('/auth/forgot-password', { email }),

  resetPassword: (token: string, password: string, confirmPassword: string) =>
    userClient.post('/auth/reset-password', { token, password, confirmPassword }),

  getMe: () => userClient.get('/users/me'),

  updateMe: (data: Record<string, string>) => userClient.put('/users/me', data),

  submitKYC: (data: { documentType: string; documentNumber: string; documentUrl: string }) =>
    userClient.post('/kyc/submit', data),

  getKYCStatus: () => userClient.get('/kyc/status'),
};
